<template>
  <footer class="footer footer-responsive">
    <div class="container-fluid footer-links-row">
      <div class="footer-link">
        <a :href="urlTerminosYCondiciones" target="_blank">Términos y Condiciones</a>
      </div>
      <div class="footer-link">
        <a :href="urlAvisoDePrivacidad" target="_blank">Aviso de Privacidad</a>
      </div>
    </div>
    <div class="container-fluid footer-meta-row">
      <div class="footer-meta">
        Versión: {{ version ? version : 'desarrollo' }}
      </div>
      <div class="footer-meta">
        &copy; {{ new Date().getFullYear() }} Correduría Digital
      </div>
    </div>
  </footer>
</template>

<script>
import { MetaInfoApi } from '@/api';
import config from '@/config';

export default {
  name: "ContentFooter",
  data: () => ({
    // Decido hardcodear la version (al menos por el momento) porque causa muchas llamadas a la api
    version: "1.1.0",
    urlAvisoDePrivacidad: config.CD_STG_BASE_URL + "/assets/documents/aviso_de_privacidad_cd_v2.pdf" + config.CD_STG_ACCESS_KEY,
    urlTerminosYCondiciones: config.CD_STG_BASE_URL + "/assets/documents/terminos_y_condiciones_cd_v3.pdf" + config.CD_STG_ACCESS_KEY,
  }),
  created() {
    // MetaInfoApi.getVersion()
    //   .then((response) => {
    //     this.version = response.frontend_version;
    //   }).catch((error) => {
    //     this.version = "N/A";
    //     console.error(error);
    //   });
  },
};
</script>

<style scoped>
.footer-responsive {
  width: 100%;
  padding: 16px 0;
  background: #dbdbdb;
  border-top: 1px solid #eee;
  font-size: 14px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-links-row,
.footer-meta-row {
  background: #dbdbdb;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  width: 100%;
  margin-bottom: 5px;
  padding-bottom: 10px;
}

.footer-link,
.footer-meta {
  margin: 0 10px;
  font-size: 16px;
  text-align: center;
}

.footer-meta {
  font-size: 16px;
  color: #666;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .footer-links-row,
  .footer-meta-row {
    flex-direction: column;
    gap: 4px;
    align-items: center;
  }
  .footer-link,
  .footer-meta {
    margin: 0;
    font-size: 13px;
  }
}
</style>
